import { SET_NEW_VERSION_AVAILABLE } from '../actionTypes';
import { releaseNotificationActions } from '../reducer';

export default (value) =>
    releaseNotificationActions[SET_NEW_VERSION_AVAILABLE](value);
